import type { QueryFunctionContext } from '@tanstack/react-query';
import { dehydrate, QueryClient } from '@tanstack/react-query';
import { Article } from 'components/pages/Article';
import { fetchPost, POST_KEY } from 'hooks/usePost';
import type { PostsQueryKey } from 'hooks/usePosts';
import { fetchPosts, POSTS_KEY } from 'hooks/usePosts';
import type { PageContext } from 'types/common/PageContext';
import { prefetchCommonData } from 'utils/buildTime';

export async function getStaticProps(context: PageContext) {
  const queryClient = new QueryClient();

  await prefetchCommonData(queryClient);

  await queryClient.prefetchQuery({
    queryKey: [POST_KEY, context.params.slug],
    queryFn: fetchPost,
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}

export const getStaticPaths = async () => {
  const queryClient = new QueryClient();

  const queryFunctionContext: QueryFunctionContext<PostsQueryKey> = {
    client: queryClient,
    queryKey: [POSTS_KEY, -1, null, null],
    signal: new AbortController().signal,
    meta: {},
  };
  const postsData = await fetchPosts(queryFunctionContext);

  const paths = postsData.posts.map((post) => ({
    params: { slug: post.slug },
  }));

  return { paths, fallback: false };
};

export default function Post() {
  return <Article />;
}
